module.exports = __webpack_public_path__ + "958179e899fdf81b47c6c46b851c5960.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-5.png
// module id = 2613
// module chunks = 0